"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURRENCY_VALUE_REGEX = exports.NUMBER_REGEX = exports.FULL_NAME_REGEX = exports.PASSWORD_REGEX = exports.EMAIL_REGEX = void 0;
/**
 * Regex expressions used across the app for validations
 */
exports.EMAIL_REGEX = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
exports.PASSWORD_REGEX = new RegExp(/^(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/);
exports.FULL_NAME_REGEX = new RegExp(/^[a-zA-Z]{1,}(?: [a-zA-Z]+)$/);
exports.NUMBER_REGEX = new RegExp(/^\s*[+-]?(\d+|\.\d+|\d+\.\d+|\d+\.)(e[+-]?\d+)?\s*$/);
exports.CURRENCY_VALUE_REGEX = new RegExp(/^(0|[1-9]\d*)(\.\d+)?$/);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVnZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uc3RhbnRzL3JlZ2V4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUVIOztHQUVHO0FBRVUsUUFBQSxXQUFXLEdBQUcsSUFBSSxNQUFNLENBQUMsNEJBQTRCLENBQUMsQ0FBQztBQUN2RCxRQUFBLGNBQWMsR0FBRyxJQUFJLE1BQU0sQ0FBQyxrREFBa0QsQ0FBQyxDQUFDO0FBQ2hGLFFBQUEsZUFBZSxHQUFHLElBQUksTUFBTSxDQUFDLDhCQUE4QixDQUFDLENBQUM7QUFDN0QsUUFBQSxZQUFZLEdBQUcsSUFBSSxNQUFNLENBQUMscURBQXFELENBQUMsQ0FBQztBQUNqRixRQUFBLG9CQUFvQixHQUFHLElBQUksTUFBTSxDQUFDLHdCQUF3QixDQUFDLENBQUMifQ==